import React from 'react';
export default () => <div className="type undefined">undefined</div>;



// WEBPACK FOOTER //
// src/core/components/types/UndefinedType.js